<template>
    <div>
        <section class="assignments-protocol">
            <div class="assignments-protocol__image-wrapper">
                <div
                    class="assignments-protocol__image"
                    :style="`background-image: url(${assignment.image})`"
                ></div>

                <div class="assignments-protocol__icon-wrapper">
                    <div
                        v-if="isCompleted"
                        :class="[
                            'assignments-protocol__icon',
                            {
                                'assignments-protocol__icon--finished': !isNotAssigned,
                                'assignments-protocol__icon--not-finished': isNotAssigned,
                            },
                        ]"
                    >
                        <svg
                            width="60"
                            height="60"
                            viewBox="0 0 76 58"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.876923 31.9C0.292308 31.32 0 30.45 0 29.87C0 29.29 0.292308 28.42 0.876923 27.84L4.96923 23.78C6.13846 22.62 7.89231 22.62 9.06154 23.78L9.35385 24.07L25.4308 41.18C26.0154 41.76 26.8923 41.76 27.4769 41.18L66.6461 0.87H66.9385C68.1077 -0.29 69.8615 -0.29 71.0308 0.87L75.1231 4.93C76.2923 6.09 76.2923 7.83 75.1231 8.99L28.3538 57.13C27.7692 57.71 27.1846 58 26.3077 58C25.4308 58 24.8462 57.71 24.2615 57.13L1.46154 32.77L0.876923 31.9Z"
                                fill="white"
                            />
                        </svg>
                    </div>

                    <div
                        v-else
                        class="assignments-protocol__icon assignments-protocol__icon--not-finished"
                    >
                        <svg
                            width="60"
                            height="60"
                            viewBox="0 0 83 83"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M41.4793 0C18.5505 0 0 18.5713 0 41.5C0 64.4287 18.5505 83 41.4793 83C64.408 83 83 64.4287 83 41.5C83 18.5713 64.408 0 41.4793 0ZM41.5 74.7C23.157 74.7 8.3 59.843 8.3 41.5C8.3 23.157 23.157 8.3 41.5 8.3C59.843 8.3 74.7 23.157 74.7 41.5C74.7 59.843 59.843 74.7 41.5 74.7ZM43.575 20.75H37.35V45.65L59.1168 58.7225L62.25 53.618L43.575 42.5375V20.75Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            <div class="assignments-protocol__body">
                <div class="assignments-protocol__title">
                    {{ assignment.course_title }}
                </div>

                <div class="assignments-protocol__details">
                    <div class="section-row">
                        <div class="section-row__col">
                            <div class="label">
                                {{ trans('reporting.label.status') }}
                            </div>

                            <div
                                :class="[
                                    'assignments-protocol__value',
                                    {
                                        'assignments-protocol__value--finished':
                                            isCompleted && !isNotAssigned,
                                    },
                                    {
                                        'assignments-protocol__value--not-finished':
                                            !isCompleted || isNotAssigned,
                                    },
                                ]"
                            >
                                {{ assignment.courseProgress_status }}
                            </div>
                        </div>

                        <div class="section-row__col">
                            <div class="label">
                                {{ trans('reporting.label.next_instruction') }}
                            </div>

                            <div class="value">
                                {{ assignment.next_assignment_at }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="assignments-protocol__buttons">
                    <button
                        class="btn btn--tertiary btn--big"
                        @click="toggleHistory"
                    >
                        {{
                            showHistory
                                ? trans(
                                      'reporting.tooltips.actions.hide_history'
                                  )
                                : trans(
                                      'reporting.tooltips.actions.show_history'
                                  )
                        }}
                    </button>

                    <a
                        v-if="isCompleted"
                        class="btn btn--primary btn--big"
                        :href="
                            route(
                                'tenant.reporting.certificate',
                                assignment.course_progresses[0].id
                            )
                        "
                    >
                        {{
                            trans(
                                'reporting.tooltips.actions.download_current_certificate'
                            )
                        }}
                    </a>
                </div>
            </div>
        </section>

        <section class="user-protocol__course-progresses">
            <course-progresses-protocol
                v-if="showHistory"
                :course-progresses="assignment.course_progresses"
            ></course-progresses-protocol>
        </section>
    </div>
</template>

<script>
export default {
    props: ['assignment'],

    data() {
        return {
            showHistory: false,
        };
    },

    computed: {
        isCompleted() {
            return this.assignment.courseProgress_status_raw == 'completed';
        },
        isNotAssigned() {
            return (
                this.assignment.courseProgress_status_computed == 'not_assigned'
            );
        },
    },

    methods: {
        toggleHistory() {
            this.showHistory = !this.showHistory;
        },
    },
};
</script>
